var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20833 0C4.39896 0 0.5 3.89896 0.5 8.70833C0.5 13.5177 4.39896 17.4167 9.20833 17.4167C14.0177 17.4167 17.9167 13.5177 17.9167 8.70833C17.9167 3.89896 14.0177 0 9.20833 0ZM12.983 7.23583C13.0525 7.15638 13.1054 7.06384 13.1386 6.96363C13.1718 6.86343 13.1847 6.7576 13.1764 6.65236C13.1681 6.54713 13.1388 6.44461 13.0903 6.35085C13.0418 6.25709 12.9751 6.17398 12.894 6.1064C12.8129 6.03882 12.7191 5.98814 12.6181 5.95734C12.5172 5.92655 12.411 5.91625 12.306 5.92707C12.201 5.93789 12.0992 5.9696 12.0067 6.02034C11.9141 6.07107 11.8326 6.13981 11.767 6.2225L8.36283 10.3067L6.60138 8.54446C6.45207 8.40025 6.25209 8.32046 6.04452 8.32226C5.83694 8.32406 5.63838 8.40732 5.4916 8.5541C5.34482 8.70088 5.26156 8.89944 5.25976 9.10702C5.25795 9.31459 5.33775 9.51457 5.48196 9.66388L7.85696 12.0389C7.93475 12.1166 8.02788 12.1773 8.13041 12.217C8.23295 12.2568 8.34265 12.2748 8.45251 12.2698C8.56237 12.2648 8.66998 12.2369 8.76849 12.1881C8.867 12.1392 8.95425 12.0703 9.02467 11.9858L12.983 7.23583Z",
    fill: "#5EB5CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.eb5c33955414ab58045c40b080442db7.svg";
export { ForwardRef as ReactComponent };